<script setup lang="ts">
import Navbar from './components/Navbar.vue'
import Hero from './components/Hero.vue'
import ProductFeatures from './components/ProductFeatures.vue'
import Terminals from './components/Terminals.vue'
import Solutions from './components/Solutions.vue'
import Stats from './components/Stats.vue'
import Cta from './components/Cta.vue'
import Footer from './components/Footer.vue'
</script>

<template>
  <div class="app">
    <Navbar />
    <main>
      <Hero />
      <ProductFeatures />
      <Solutions />
      <Terminals />
      <Stats />
      <Cta />
    </main>
    <Footer />
  </div>
</template>

<style scoped>
.app {
  min-height: 100vh;
}
</style>
